import type { MailOrderShippingZone } from '../../../types/location'

/** Appended to a duplicated zone's name, e.g. "Manitoba" -> "Manitoba (copy)". */
export const CLONE_NAME_SUFFIX = ' (copy)'

/** Name for a duplicated zone: trimmed source name + `CLONE_NAME_SUFFIX`. */
export function cloneZoneName(name: string): string {
  return `${(name ?? '').trim()}${CLONE_NAME_SUFFIX}`
}

/**
 * Seed for a duplicated mail order zone. The province/state is cleared because
 * the backend rejects two zones for the same country + state; every rule
 * (fees, tax override, excluded categories) is carried over. Never shares the
 * `excluded_categories` array with the source.
 */
export function cloneMailOrderZone(
  zone: MailOrderShippingZone,
  fallbackName: string,
): MailOrderShippingZone {
  return {
    ...zone,
    name: cloneZoneName(zone.name?.trim() ? zone.name : fallbackName),
    state: '',
    excluded_categories: [...(zone.excluded_categories ?? [])],
  }
}
